import { api } from './api';
import type { FxRateKind } from './fxRates';

export type ConsolidationMode = 'pl' | 'balance_sheet';

export interface ConsolidatedLine {
  accountCode: string;
  amount: number;
  entityCount: number;
  sourceCurrencies: string[];
  rateKind?: FxRateKind;
  statementType?: string | null;
}

export interface IcMatch {
  accountCode: string;
  entityId: string | null;
  counterpartyId: string | null;
  currency: string;
  matchedAmount: number;
}

export interface ConsolidationResult {
  reportingCurrency: string;
  period: { start: string; end: string };
  rateKind: FxRateKind;
  rootEntityId: string;
  entityIds: string[];
  totalAmount: number;
  lines: ConsolidatedLine[];
  ratesUsed: { from: string; to: string; rate: number; date: string }[];
  missingRates: { from: string; to: string }[];
  mode: ConsolidationMode;
  cta?: { amount: number; available: boolean; reason?: string };
  icMatched?: number;
  icResidual?: number;
  icPairs?: IcMatch[];
}

export interface ConsolidationQuery {
  periodStart: string;
  periodEnd: string;
  reportingCurrency: string;
  rootEntityId?: string;
  rateKind?: FxRateKind;
  mode?: ConsolidationMode;
  perAccountRateKinds?: boolean;
  icPairMatch?: boolean;
  eliminateIntercompany?: boolean;
}

export const consolidationApi = {
  async run(workspaceId: string, q: ConsolidationQuery): Promise<ConsolidationResult> {
    const r = await api.get<ConsolidationResult>(
      `/api/workspaces/${workspaceId}/consolidate`,
      { params: q },
    );
    return r.data;
  },
};
